var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_Salinity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,0S67.31,52.3,45.09,96C33.66,118.55,25,138.79,25,148.46,25,176.93,58.58,200,100,200s75-23.07,75-51.54S100,0,100,0ZM94.45,128.12a10.83,10.83,0,1,1,10.82-10.82A10.83,10.83,0,0,1,94.45,128.12Zm-36.81-4.85L76,149.81H40.91Zm22.52,64.57A10.83,10.83,0,1,1,91,177,10.83,10.83,0,0,1,80.16,187.84ZM67,82.6A10.83,10.83,0,1,1,77.8,93.42,10.83,10.83,0,0,1,67,82.6Zm47.78,7.05a10.83,10.83,0,1,1,10.83-10.82A10.81,10.81,0,0,1,114.75,89.65Zm28.82,11.21L162,127.4H126.84Zm-39.9,57.2,27.85-14.46L134,175.79ZM116.05,46.27,86.85,60.05,92.6,25.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalinity);
export default __webpack_public_path__ + "static/media/Salinity.e265a2b54be1f1764dc8dc241ec3fb24.svg";
export { ForwardRef as ReactComponent };